import { Form, useFormikContext } from "formik";

import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";

import InputField from "common/components/form-fields/input/input.container";
import loginFormStyles from "features/login-screen/login-form/views/login-form.styles";

const useStyles = makeStyles(loginFormStyles);

function UserIdForm() {
  const classes = useStyles();
  const { isValid, isSubmitting } = useFormikContext();
  return (
    <Form className={classes.form}>
      <InputField
        name="userId"
        variant="filled"
        label="User ID"
        fullWidth
        margin="normal"
        className={classes.field}
      />
      <Button
        variant="contained"
        type="submit"
        fullWidth
        disabled={!isValid || isSubmitting}
        className={classes.button}
      >
        Next
      </Button>
    </Form>
  );
}

export default UserIdForm;
